import adminApi from '../../apis/adminApi';

export function AddInfoContentService(values) {
  return adminApi.post('/api/admin/info-content', values).then((res) => res.data);
}

export function GetInfoContentService(params) {
  return adminApi.get('/api/admin/info-content', { params }).then((res) => res.data);
}
